import {createSlot} from '../../utils/react';

export const [
  DashboardHeaderActionsSlotProvider,
  DashboardHeaderActionsSlotArea,
  DashboardHeaderActionsSlot,
] = createSlot();
